<template>
    <MainContentTabs
        :tabs="[
            {tab : 'precios-abonos', nombre: 'Configurar precios de los abonos'},
            {tab : 'vouchers', nombre: 'Configurar cupones de descuento'}
        ]"
        initialTab="precios-abonos"
    >
        <template slot="precios-abonos">     
            <TabPrices v-if="lista.place"/>
            <TabPricesSinRecinto v-else/>
        </template>
        <template slot="vouchers">
            <TabVouchers/>
        </template>
    </MainContentTabs>
</template>

<script>

import TabPrices from './tabs/TabPrices.vue';
import MainContentTabs from '@/components/backend/components/MainContentTabs.vue';
import TabVouchers from './tabs/TabVouchers.vue';
import TabPricesSinRecinto from './tabs/TabPricesSinRecinto.vue';

export default {
    components: {
        TabPrices, MainContentTabs, TabVouchers, TabPricesSinRecinto
    },
    computed: {
        lista() {
            return this.$store.getters.getListaAbonados;
        }
    }
}
</script>